import type { Dispatch, SetStateAction } from "react";

import { EntityTagFieldV2 } from "src/components/TagManagement/EntityTagFieldV2";
import { ProductFormType } from "src/pages/Product/ProductForm/ProductForm.types";

type ProductTagFieldV2Props = {
    product: ProductFormType;
    setProduct: Dispatch<SetStateAction<ProductFormType>>;
};

export const ProductTagFieldV2 = (props: ProductTagFieldV2Props) => {
    const { product, setProduct } = props;

    return (
        <EntityTagFieldV2
            context="product"
            tags={product.tags}
            onTagsChange={(tags) => setProduct((current) => ({ ...current, tags }))}
        />
    );
};
